import SEOHead from '../components/SEO/SEOHead';
import Pricing from '../components/Pricing/List';
// import Download from '../components/Downloads/Download';
import queryOffers from '../services/offers_products/queryOffers';
import { useTranslation } from 'react-i18next';
import Header from '../components/Layout/Header';
import SpecialOffers from '../components/Home/SpecialOffers';
import Footer from '../components/Layout/Footer';

export default function Offers() {
  const {t} = useTranslation();
  const { data: basic, isLoading: isLoadingBasic } = queryOffers().productsAll();

  const dataMovil = basic?.filter((item) => item.type === 'movil' && item.status) || [];
  const dataNauta = basic?.filter((item) => item.type === 'nauta' && item.status) || [];

  return (
    <>
      <SEOHead
        title="Precios y Ofertas de Recarga a Cuba"
        description="Consulta los precios actuales de recargas móviles a Cuba. Tarifas competitivas, ofertas especiales y recargas Nauta disponibles. Actualizado diariamente."
        path="/offerts"
        schemas={['Organization', 'Service']}
      />
      <div className="fixed inset-x-0 top-0 z-50 ">
        <Header />
      </div>

      <div className="pt-80 md:pt-48 flex flex-col gap-20">
        {/* Pricing */}
        <Pricing
          offers={dataMovil}
          title={t('offers.title1')}
          subtitle={t('offers.subtitle1')}
          isLoading={isLoadingBasic}
        />

        {/* Process List */}
        <SpecialOffers />

        {!!dataNauta?.length && <div>
          <Pricing
            special
            offers={dataNauta}
            color
            title={t('offers.title3')}
            isLoading={isLoadingBasic}
          />
        </div>}

        {/* Download */}
        {/* <Download /> */}
        <div className='w-full'>
          <Footer />
        </div>
      </div>
    </>
  );
}
